export default __webpack_public_path__ + "static/media/bg-purple-waves-large.ecb74b03.png";